import { recursiveFlattenBundlesObjects } from 'utils/xtra-request-bundle/createStandardRequestBundle';
import { combineEpics } from 'redux-observable';

export const boothEditRequests = {
};

export const boothEditRequestsEpics = combineEpics(...recursiveFlattenBundlesObjects(boothEditRequests).map((bundle) => bundle.epic));
